import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { useSecondSideBarOpen } from "stores/wizardStore";
import { LeftSidebarSubNavHeader } from "./LeftSidebarSubNavHeader";
import s from "./LeftSidebar.module.scss";
import { SideBarWrapper } from "./SideBarWrapper";

type LeftSidebarFinalSubnavProps = {
  activeItem: Scrivito.Obj;
  children: React.ReactElement;
};

export const LeftSidebarFinalSubnav = Scrivito.connect(
  ({ activeItem, children }: LeftSidebarFinalSubnavProps) => {
    const isSecondSideBarOpen = useSecondSideBarOpen();
    return (
      <SideBarWrapper
        width={348}
        isOpenDefault={isSecondSideBarOpen}
        withToggle
        isFirstSidebar
        toggleText="LEFT_SIDEBAR_MAIN_MENU"
        isRightSidebarToggle={false}
        classNames="sideBarWidth"
      >
        <div
          data-testid="wizard-left-sidebar"
          className={cx(
            "h-full-exclude-footer bg-gray-700",
            s.leftSidebarFinalSubnavWrapper,
          )}
        >
          <div className="ps-1">
            <div
              role="button"
              className={cx(
                s.leftSidebarSubNavTitle,
                "ps-4 py-3 d-flex align-items-center",
              )}
            >
              <LeftSidebarSubNavHeader
                isFinalSubNav
                referenceObj={activeItem}
              />
            </div>
          </div>
          <ul className={cx("list-unstyled mt-0", { "ps-1": !!activeItem })}>
            {children}
          </ul>
        </div>
      </SideBarWrapper>
    );
  },
);
